"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generatePath = generatePath;
exports.generateQueryString = generateQueryString;
exports.validateParams = validateParams;

var _pathToRegexp = _interopRequireDefault(require("path-to-regexp"));

var _querystringify = _interopRequireDefault(require("querystringify"));

var _warning = _interopRequireDefault(require("warning"));

var _isEmptyObject = _interopRequireDefault(require("./isEmptyObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];

  var generator = _pathToRegexp.default.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}

function generatePath() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

function generateQueryString(paramDefs) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!paramDefs || (0, _isEmptyObject.default)(paramDefs)) {
    return null;
  }

  if ((0, _isEmptyObject.default)(params)) {
    return null;
  }

  var queryStringParams = Object.keys(params).filter(function (key) {
    return Object.keys(paramDefs).indexOf(key) > -1;
  }).reduce(function (acc, key) {
    var value = params[key] === 'undefined' ? undefined : params[key] === 'null' ? null : params[key];
    var paramDef = paramDefs[key];
    return paramDef.default() === value ? acc //avoid query string clutter: don't serialize values that are the same as the default
    : _objectSpread(_defineProperty({}, key, params[key]), acc);
  }, null);
  return _querystringify.default.stringify(queryStringParams);
}

function validateParams(paramSchema, params) {
  var generateWarning = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!paramSchema) {
    return true;
  }

  try {
    paramSchema.validateSync(params);
  } catch (err) {
    var name = err.name,
        errors = err.errors;

    if (name === 'ValidationError') {
      if (generateWarning) (0, _warning.default)(false, "validateParams: ".concat(errors[0]));
    } else {
      throw err;
    }

    return false;
  }

  return true;
}